import secureApi from "../services/secureApi";

export const getPaymentList = async (
  page = 1,
  limit = 10,
  search = ""
) => {
  const response = await secureApi.get("/admin/payments/list", {
    params: {
      page,
      limit,
      search,
    },
  });

  return response.data;
};

export const getPaymentDetails = async () => {
  const response = await secureApi.get("/admin/payments/details");

  return response.data;
};
